'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiArrowDownOutline = function TiArrowDownOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 35.5l-11.9-11.8c-1.9-2-1.9-5.2 0-7.1 1.9-1.8 5-1.9 6.9-0.2v-8.1c0-2.7 2.2-5 5-5s5 2.3 5 5v8.1c1.9-1.7 5-1.6 6.9 0.2 1.9 1.9 1.9 5.1 0 7.1l-11.9 11.8z m-8.3-17c-0.5 0-0.9 0.1-1.2 0.4-0.7 0.7-0.7 1.7 0 2.4l9.5 9.5 9.5-9.5c0.7-0.7 0.7-1.7 0-2.4-0.6-0.6-1.7-0.6-2.3 0l-5.5 5.5v-16.1c0-0.9-0.8-1.6-1.7-1.6s-1.7 0.7-1.7 1.6v16.1l-5.5-5.5c-0.3-0.3-0.7-0.4-1.1-0.4z' })
        )
    );
};

exports.default = TiArrowDownOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/arrow-down-outline.js
// module id = 2967
// module chunks = 0